module.exports = __webpack_public_path__ + "static/media/vegard.ede1c15e.JPG";